import { Icon, IconProps } from "../Icon";

const Information = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 26C4.0011 27.1041 4.89589 27.9989 6 28H26C27.1041 27.9989 27.9989 27.1041 28 26V6C27.9989 4.89589 27.1041 4.0011 26 4H6C4.89589 4.0011 4.0011 4.89589 4 6V26ZM6 26V6H26L26.001 26H6ZM17 22V13H13V15H15V22H12V24H20V22H17ZM14.5 9.83333C14.5 9.00491 15.1716 8.33333 16 8.33333C16.8284 8.33333 17.5 9.00491 17.5 9.83333C17.5 10.6618 16.8284 11.3333 16 11.3333C15.1716 11.3333 14.5 10.6618 14.5 9.83333Z"
      fill="currentColor"
    />
  </Icon>
);

export default Information;
